module.exports = __webpack_public_path__ + "img/coupons_icon_used_cn.62650e0f.png";